const setSliderWidth = () => {
    const sliderTrack = document.getElementById('slider-track');
    if (!sliderTrack) {
        console.warn('Element with ID "slider-track" not found.');
        return;
    }
    const slides = Array.from(sliderTrack.children);

    // Duplicate the slides to create a seamless loop
    slides.forEach(slide => {
        const clone = slide.cloneNode(true);
        sliderTrack.appendChild(clone);
    });

    // Find the longest slide width
    let maxWidth = 0;
    slides.forEach(slide => {
        const slideWidth = slide.offsetWidth;
        if (slideWidth > maxWidth) {
            maxWidth = slideWidth;
        }
    });

    // Set all slides to the width of the longest slide
    const allSlides = document.querySelectorAll(".frontpage-slider #slider-track .slide");
    allSlides.forEach(slide => {
        slide.style.width = `${maxWidth}px`;
    });

    // Calculate the total width after setting all slides to the max width
    const totalWidth = maxWidth * allSlides.length;
    sliderTrack.style.width = `${totalWidth}px`;
}

export { setSliderWidth };
